// removed by extract-text-webpack-plugin
module.exports = {"checkEligibleBtn":"checkEligibleBtn__fWlX3","checkEligibleBtnCustom":"checkEligibleBtnCustom__20Fx6"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVMerchant/checkEligibilityBtn/style.css
// module id = YIhJ
// module chunks = 458